import { region } from '#shared/constants/firebase'

/**
 * Composable for image-related functionality
 */
export function useImage() {
    const config = useRuntimeConfig()

    /**
     * Gets the API base URL (works on both SSR and client)
     */
    function getApiBaseUrl(): string {
        const projectId = config.public.FIREBASE_PROJECT_ID
        const isEmulator = config.public.FIREBASE_USE_EMULATOR === 'true'

        return isEmulator
            ? `http://localhost:5001/${projectId}/${region}/api`
            : `https://${region}-${projectId}.cloudfunctions.net/api`
    }

    /**
     * Parse an image URL to handle various formats
     */
    const parseImgURL = (src: string | undefined): string | undefined => {
        if (!src || !(typeof(src) === 'string') ) return undefined
        if (src.startsWith('https://firebasestorage.googleapis.com')) {
            return src.split('https://firebasestorage.googleapis.com').join('')
        }

        if (src.startsWith('https://img.youtube.com')) {
            return src.split('https://img.youtube.com').join('')
        }

        if (src.startsWith('https://blog.growni.sk')) {
            return src.split('https://blog.growni.sk').join('')
        }

        return src
    }

    /**
     * Image variant options
     */
    enum Variant {
        'Z' = 'Z',
        'A' = 'A',
        'B' = 'B',
        'C' = 'C',
        'D' = 'D',
        'E' = 'E'
    }

    /**
     * Generate an image URL with variant transformation
     */
    const generateImage = (url: string, variant: Variant) => {
        return url.startsWith('https://img.youtube.com')
            ? url
            : `${getApiBaseUrl()}/image/${variant}?url=${encodeURIComponent(url)}`
    }

    return {
        parseImgURL,
        generateImage,
        Variant
    }
}
